import React from 'react';
import PropTypes from 'prop-types';

import useCasinoSearchPosthog from './useCasinoSearchPosthog';

const CasinoSearchPosthogContext = React.createContext(null);

export const useCasinoSearchPosthogContext = () => React.useContext(CasinoSearchPosthogContext);

export const CasinoSearchPosthogProvider = ({ children, isSearchActive, searchQuery }) => {
  const value = useCasinoSearchPosthog({ isSearchActive, searchQuery });

  return (
    <CasinoSearchPosthogContext.Provider value={value}>
      {children}
    </CasinoSearchPosthogContext.Provider>
  );
};

CasinoSearchPosthogProvider.propTypes = {
  children: PropTypes.node,
  isSearchActive: PropTypes.bool,
  searchQuery: PropTypes.string,
};
